/*
 * @Author: 刘小博
 * @Date: 2023-02-07 14:26:39
 * @LastEditTime: 2023-02-19 18:16:59
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: /p2ps_vip_web/src/router/behavior-manage/work-center/modules/workReportRouter.js
 * 工作报告
 */
const workReportRouter = [
  // 行为管理 工作报告配置 周报
  {
    path: '/behaviorManage/work-report-week/:account_id/:quarter_id/:date',
    name: 'behaviorManageWorkWorkReportWeek',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage4" */
      //   '@/views/behaviorManage/workReport/WorkReportWeek.vue'
      // ), //待删除文件
      import(
        /*webpackChunkName:"behaviorManage4" */
        '@/views/behavior-manage/work-center/work-report/weekly/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '工作报告', //二级菜单
      title: '工作周报',
    },
  },
  // 行为管理 工作报告配置 周报 离职人员周报
  {
    path: '/behaviorManage/work-report-week/:account_id/:quarter_id/:date/:Resignation',
    name: 'behaviorManageWorkWorkReportWeekResignation',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage4" */
      //   '@/views/behaviorManage/workReport/WorkReportWeek.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManage4" */
        '@/views/behavior-manage/work-center/work-report/weekly/ResignWeek.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '工作报告', //二级菜单
      title: '离职人员工作周报',
      breadcrumb: [
        {
          title: '工作周报',
          name: 'behaviorManageWorkWorkReportWeek',
        },
      ],
    },
  },
  // 行为管理 工作报告配置 月报
  {
    path: '/behaviorManage/work-report-month/:account_id/:date',
    name: 'behaviorManageWorkWorkReportMonth',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage4" */
      //   '@/views/behaviorManage/workReport/WorkReportMonth.vue'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManage4" */
        '@/views/behavior-manage/work-center/work-report/monthly/Page.vue'
      ),   //新迁移文件
    meta: {
      SecondaryMenu: '工作报告', //二级菜单
      title: '工作月报',
    },
  },
  // 行为管理 工作报告配置 月报 离职人员月报
  {
    path: '/behaviorManage/work-report-month/:account_id/:date/:Resignation',
    name: 'behaviorManageWorkWorkReportMonthResignation',
    component: () =>
      //   import(
      //     /*webpackChunkName:"behaviorManage4" */
      //     '@/views/behaviorManage/workReport/WorkReportMonth.vue'
      //   ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManage4" */
        '@/views/behavior-manage/work-center/work-report/monthly/ResignMonth.vue'
      ),   //新迁移文件
    meta: {
      SecondaryMenu: '工作报告', //二级菜单
      title: '离职人员月报',
      breadcrumb: [
        {
          title: '工作月报',
          name: 'behaviorManageWorkWorkReportMonth',
        },
      ],
    },
  },
]
export default workReportRouter
